import styled from "styled-components";
import { CommonIonButton } from "../../common-styles";

export const Details = styled.div`
  margin-top: 1rem;
  position: relative;
  height: 300px;
`;

export const ProfileBackgroundImage = styled.img`
  position: absolute;
  border-radius: 10px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  opacity: 0.72;
  transition: opacity 180ms ease-out;

  &[data-loaded="true"] {
    opacity: 1;
  }
`;

export const SubscribeBtn = styled(CommonIonButton)`
  z-index: 5;
  border: none;
  background: linear-gradient(90deg, #c1effe 0%, #d5c2fd 51.5%, #e9b9fe 100%);
  padding: 0.8rem 1rem;
  border-radius: 50px;
  width: unset;
  box-shadow: 0px 0px 7px 2px #00000040;
  span {
    font-size: 15px;
    font-weight: 600;
    color: black;
  }
`;

export const DetailsFooter = styled.div`
  position: absolute;
  width: calc(100% - 2rem);
  bottom: -1.2rem;
  left: 1rem;
`;

export const CountDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 1rem;
  border-right: 1px solid black;
  &:last-child {
    padding-right: 0;
    border: 0;
  }
`;

export const ProfileImage = styled.img`
  width: 130px;
  height: 130px;
  min-width: 130px;
  min-height: 130px;
  border-radius: 50%;
  border: 4px solid #ffffff;
  object-fit: cover;
  background: linear-gradient(110deg, #111111 0%, #292929 48%, #111111 100%);
  opacity: 0.72;
  transition: opacity 180ms ease-out;

  &[data-loaded="true"] {
    opacity: 1;
  }
  @media screen and (max-width: 425px) {
    width: 100px;
    height: 100px;
    min-width: 100px;
    min-height: 100px;
  }
`;

export const ProfileContent = styled.img``;

export const ProfileHeaderContainer = styled.div`
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;
  overflow-x: hidden;
  padding: 1rem;
  margin: auto;
  .section-one {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    height: 300px;
    margin-top: 0.6rem;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    background: linear-gradient(
      91.66deg,
      #bda0cb 4.78%,
      #a596cb 47.99%,
      #837fcb 98.72%
    );
    /* display: flex; */
    align-items: center;
    justify-content: center;
    border: 2px solid #fff;

    button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .section-two {
    max-width: 750px;
    width: 95%;
    min-width: 0;
    margin: auto;
    span {
      position: relative;
      top: 8px;
    }
  }

  .section-three {
    margin-bottom: 1rem;
    min-width: 0;
    overflow-x: hidden;
    font-weight: 1.1rem;
    .profile-link-icon {
      width: 22px;
      height: 22px;
      flex: 0 0 22px;
    }

    textarea {
      border: none;
      outline: none;
      box-shadow: none !important;
      background-color: black;
      color: rgba(255, 255, 255, 0.7);
      font-size: 1.1rem;
      &::placeholder {
        color: rgba(255, 255, 255, 0.7);
      }
      &::active {
        box-shadow: none !important;
      }
    }
  }

  @media screen and (max-width: 425px) {
    .profile-link-icon {
      width: 20px;
      height: 20px;
      flex-basis: 20px;
    }

    .section-one {
      height: unset;
      aspect-ratio: 5/3;
    }
  }
`;

export const JoinBtn = styled.button`
 cursor: pointer;
  flex: none;
  background: linear-gradient(90deg, #DB77E5 0%, #7A5BC9 48.5%, #4B4DBB 100%);
  color: white;
  padding: .8rem .9rem;
  border-radius: 50px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: .5rem;
`

export const QuickAction = styled.div`
  border-radius: 50px;
  cursor: pointer;
  flex: none;
  background: linear-gradient(90deg, #c1effe 0%, #d5c2fd 51.5%, #e9b9fe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 7px 2px #00000040;
  font-weight: 500;
  gap: 0.5rem;
  padding: 0.8rem 0.9rem;

  /* Hide on web (desktop) */
  @media screen and (min-width: 1025px) {
    display: none;
  }
`;


export const QuickActionMsgWeb = styled.div`
  border-radius: 50px;
  cursor: pointer;
  flex: none;
  background: linear-gradient(90deg, #c1effe 0%, #d5c2fd 51.5%, #e9b9fe 100%);
  display: none; /* Hide by default (mobile/tablet) */
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 7px 2px #00000040;
  font-weight: 500;
  gap: 0.5rem;
  padding: 0.8rem 0.9rem;

  /* Show only on web (desktop) */
  @media screen and (min-width: 1025px) {
    display: flex;
  }
`;
export const ProfileOwnerActions = styled.div`
  position: relative;
  z-index: 20;
  flex: 0 0 auto;
  width: fit-content;
  margin: 0.1rem 0 0 auto;
`;

export const ProfileEditTrigger = styled.button`
  position: relative;
  width: 42px;
  height: 42px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #0d6ac3 0%, #c87ae3 54%, #fd9101 100%);
  color: #ffffff;
  cursor: pointer;
  display: grid;
  place-items: center;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.42);
  transition: box-shadow 180ms ease, transform 180ms ease;

  &::before {
    content: "";
    position: absolute;
    inset: 2px;
    border-radius: inherit;
    background: #0b0b0b;
  }

  svg {
    position: relative;
    z-index: 1;
    width: 18px;
    height: 18px;
  }

  &:hover,
  &:focus-visible {
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.5), 0 0 18px rgba(200, 122, 227, 0.4);
    transform: translateY(-1px);
  }
`;

export const ProfileEditMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: min(208px, calc(100vw - 32px));
  padding: 1px;
  border-radius: 14px;
  background: linear-gradient(135deg, #0d6ac3 0%, #c87ae3 54%, #fd9101 100%);
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.5), 0 0 18px rgba(200, 122, 227, 0.16);
  overflow: hidden;

  button,
  span {
    position: relative;
    z-index: 1;
  }

  button {
    width: 100%;
    min-height: 46px;
    border: 0;
    background: #0b0b0b;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 180ms ease, text-shadow 180ms ease;
  }

  button:first-child {
    border-radius: 13px 13px 0 0;
  }

  button:last-child {
    border-radius: 0 0 13px 13px;
  }

  button:hover,
  button:focus-visible {
    background: radial-gradient(circle at center, rgba(200, 122, 227, 0.18), rgba(11, 11, 11, 0.96) 64%), #0b0b0b;
    text-shadow: 0 0 14px rgba(200, 122, 227, 0.45);
    outline: none;
  }

  span {
    display: block;
    height: 1px;
    background: rgba(255, 255, 255, 0.12);
  }
`;
